;(function () {
	// NAV VISIBILITY CONTROL
	function applyNavVisibility() {
		// Default to b2b mode (show everything) if retail context not available yet
		const mode = window.retailContext?.mode || 'b2b';
		
		// Find all desktop nav items
		const allNavItems = document.querySelectorAll('.list-menu-item');
		
		allNavItems.forEach(listItem => {
			const link = listItem.querySelector('.header__menu-item');
			if (!link) return;
			
			const linkText = link.textContent.trim().toLowerCase();
			
			// Determine which links to show based on mode
			let shouldShow = false;
			
			if (mode === 'b2b') {
				// B2B: show everything
				shouldShow = true;
			} else if (mode === 'retail-generic') {
				// Retail-generic: show Shop, Home, About Us, and Legal/Policy pages
				shouldShow = (
					linkText.includes('shop') ||
          			linkText.includes('collections') ||
					linkText.includes('home') ||
					linkText.includes('about') ||
					linkText.includes('legal') ||
					linkText.includes('policy') ||
					linkText.includes('privacy') ||
					linkText.includes('terms') ||
					linkText.includes('refund') ||
					linkText.includes('shipping') ||
          linkText.includes('news') ||
          linkText.includes('platform')
				);
			} else if (mode === 'retail') {
				// Full retail: only show Shop
				shouldShow = linkText.includes('shop');
			}
			
			if (!shouldShow) {
				listItem.setAttribute('data-hidden-by-retail', 'true');
			} else {
				listItem.removeAttribute('data-hidden-by-retail');
			}
		});

		// Hide Brands column in the Shop/Collections mega menu for retail modes
		const brandColumns = document.querySelectorAll('[data-brands-column="true"]');
		brandColumns.forEach((column) => {
			if (mode !== 'b2b') {
				column.style.display = 'none';
				column.setAttribute('data-hidden-by-retail', 'true');
			} else {
				column.style.display = '';
				column.removeAttribute('data-hidden-by-retail');
			}
		});
		
		// Handle logo navigation
		const logoLinks = document.querySelectorAll('.header__heading-link');
		logoLinks.forEach(logoLink => {
			if (mode === 'retail') {
				// Full retail: disable logo navigation
				logoLink.style.pointerEvents = 'none';
				logoLink.style.cursor = 'default';
				logoLink.setAttribute('data-retail-disabled', 'true');
			} else {
				// B2B and retail-generic: allow logo navigation to homepage
				logoLink.style.pointerEvents = '';
				logoLink.style.cursor = '';
				logoLink.removeAttribute('data-retail-disabled');
			}
		});
	}

	// SHOP/COLLECTIONS LABEL CONTROL
	function updateShopLabel() {
		const mode = window.retailContext?.mode || 'b2b';
		
		// Find all links with data-original-title attribute (both desktop and mobile)
		const allLinks = document.querySelectorAll('[data-original-title]');
		
		allLinks.forEach(element => {
			const originalTitle = element.getAttribute('data-original-title');
			
			// Only process links with "Shop" as original title (case-insensitive)
			if (originalTitle && originalTitle.toLowerCase() === 'shop') {
				// Get the text node to update (span for desktop links, direct text for mobile)
				const textContainer = element.querySelector('span') || element;
				
				if (mode === 'retail-generic') {
					// In retail-generic mode, change "Shop" to "Collections"
					textContainer.textContent = 'Collections';
					element.setAttribute('aria-label', 'Collections');
					element.setAttribute('title', 'Collections');
				} else {
					// In all other modes (b2b, retail), restore to "Shop"
					textContainer.textContent = originalTitle;
					element.setAttribute('aria-label', originalTitle);
					element.setAttribute('title', originalTitle);
				}
			}
		});
	}

	const header = () => {
		// Apply nav visibility control FIRST
		// Wait a tick to ensure window.retailContext is available
		Promise.resolve().then(() => {
			applyNavVisibility()
			updateShopLabel()
		})
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		let hideMenuTimeout

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search.isOpen) {
				search.close()
			}
		})

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		const megaMenus = document.querySelectorAll('.mega-menu')

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				clearTimeout(hideMenuTimeout)

				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return

					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'grid'
							setTimeout(() => {
								megaMenu.style.opacity = 1
							}, 100)
						}

						const headerMain = header.querySelector('.header')

						const calcPosition = () => {
							megaMenu.style.right = 'auto'
							const retailMode = document.documentElement.getAttribute('data-retail-mode') || 'b2b'
							const isShopCollections = megaMenu.classList.contains('mega-menu--shop-collections')
							if (isShopCollections && retailMode !== 'b2b') {
								const columns = megaMenu.querySelector('.mega-menu__columns')
								if (columns) {
									megaMenu.style.width = `${columns.scrollWidth}px`
								}
							} else {
								megaMenu.style.width = ''
							}

							const megaMenuTabs = megaMenu.querySelector('.mega-menu__tabs')

							if (megaMenuTabs) {
								if (megaMenuTabs.scrollWidth > megaMenu.offsetWidth) {
									megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`
									megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`
								}
							}

							const megaMenuRight = megaMenu.getBoundingClientRect().right
							const headerRight = headerMain.getBoundingClientRect().right

							if (megaMenuRight > headerRight) {
								megaMenu.style.right = '2rem'
							}
						}

						calcPosition()

						let headerMainWidth = headerMain.offsetWidth

						const resizeObserver = new ResizeObserver((entries) => {
							for (const entry of entries) {
								const newWidth = entry.contentRect.width

								if (newWidth !== headerMainWidth) {
									headerMainWidth = newWidth
									calcPosition()
								}
							}
						})

						resizeObserver.observe(headerMain)
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
			link.addEventListener('mouseleave', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'none'
							hideMenuTimeout = setTimeout(() => {
								megaMenu.style.display = 'none'
							}, 100)
						}
					})
				}
			})
			link.addEventListener('focus', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						const megaMenuPositionRight = megaMenu.getBoundingClientRect().right
						const windowRight = window.innerWidth
						if (megaMenuPositionRight > windowRight) {
							megaMenu.style.right = '0'
						}
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
		})
		menu.addEventListener('mouseleave', (e) => {
			if (!megaMenus) return
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = 'auto'
					megaMenu.style.display = 'none'
				})
			}, 100)
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})
		menu.addEventListener('focusout', (e) => {
			if (!megaMenus) return
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = 'auto'
				})
			}, 500)
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main.querySelectorAll('.shopify-section')[0] &&
			main
				.querySelectorAll('.shopify-section')[0]
				.classList.contains('section--has-overlay')
		) {
		}

		const menuCloseBtn = document.querySelector('.header__modal-close-button')
		const mobileMenuDrawer = document.querySelector('header-drawer')
		menuCloseBtn.addEventListener('click', (e) => {
			mobileMenuDrawer.closeMenuDrawer(e)
		})
	}

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)
	
	// Watch for retail mode changes via MutationObserver
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'attributes' && mutation.attributeName === 'data-retail-mode') {
				applyNavVisibility();
				updateShopLabel();
			}
		});
	});
	
	observer.observe(document.documentElement, {
		attributes: true,
		attributeFilter: ['data-retail-mode']
	});

	// Apply initial nav visibility once current call stack completes.
	// At this point, window.retailContext should already be initialized by the
	// head script in theme.liquid; applyNavVisibility safely defaults to 'b2b'
	// if retailContext is not yet available.
	Promise.resolve().then(() => {
		applyNavVisibility();
		updateShopLabel();
	});

	header()
})()
